import React, { Component } from "react";
import axios from "axios";
import ApiURL from "../../api/ApiURL";
import cogoToast from "cogo-toast";
import DataLoader from "../common/DataLoader";
import DashboardKPICards from "./DashboardKPICards";
import DashboardCharts from "./DashboardCharts";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            monthlyLeadCount: 0,
            monthlyConvertedLeadCount: 0,
            yearlyLeadCount: 0,
            yearlyConvertedLeadCount: 0,
            monthlyTrend: [],
        };
    }

    componentDidMount() {
        this.loadDashboardData();
    }

    loadDashboardData = () => {
        this.setState({ loading: true });

        Promise.all([
            axios.get(ApiURL.GetLeadKPIData),
            axios.get(ApiURL.GetLeadKPIChartData),
        ])
            .then(([kpiResponse, chartResponse]) => {
                const kpiData = kpiResponse.data;
                const chartData = chartResponse.data;

                if (kpiData.StatusCode === 500) {
                    cogoToast.error("Internal Server Error ! Please Try Again.", { position: "bottom-center" });
                    return;
                }

                if (chartData.StatusCode === 500) {
                    cogoToast.error("Failed to load chart data. Please Try Again.", { position: "bottom-center" });
                }

                const kpiResult = kpiData.StatusCode === 200 ? kpiData.DataResult : {};
                const chartResult = chartData.StatusCode === 200 ? chartData.DataResult : {};

                this.setState({
                    monthlyLeadCount: kpiResult.MonthlyLeadCount || 0,
                    monthlyConvertedLeadCount: kpiResult.MonthlyConvertedLeadCount || 0,
                    yearlyLeadCount: kpiResult.YearlyLeadCount || 0,
                    yearlyConvertedLeadCount: kpiResult.YearlyConvertedLeadCount || 0,
                    monthlyTrend: chartResult.MonthlyTrend || [],
                });
            })
            .catch(() => {
                cogoToast.error("Request Failed! Please Try Again.", { position: "bottom-center" });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render() {
        const {
            loading,
            monthlyLeadCount,
            monthlyConvertedLeadCount,
            yearlyLeadCount,
            yearlyConvertedLeadCount,
            monthlyTrend,
        } = this.state;

        const kpi = {
            monthlyLeadCount,
            monthlyConvertedLeadCount,
            yearlyLeadCount,
            yearlyConvertedLeadCount,
        };

        return (
            <>
                {loading ? (
                    <div className="dashboard-loader">
                        <DataLoader />
                    </div>
                ) : (
                    <>
                        <DashboardKPICards
                            monthlyLeadCount={monthlyLeadCount}
                            monthlyConvertedLeadCount={monthlyConvertedLeadCount}
                            yearlyLeadCount={yearlyLeadCount}
                            yearlyConvertedLeadCount={yearlyConvertedLeadCount}
                        />
                        <DashboardCharts monthlyTrend={monthlyTrend} kpi={kpi} />
                    </>
                )}
            </>
        );
    }
}

export default Dashboard;
